const state = {
  consultationType: 1
}

const mutations = {
  SET_TYPE (state, payload) {
    state.consultationType = payload
  }
}

const actions = {
  setConsultationType ({ commit }, data) {
    commit('SET_TYPE', data)
  },
}

const getters = {
  getSelectedConsultationType: (state) => state.consultationType
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
